module.exports = __webpack_public_path__ + "static/Lean_startup_mindset-4ceaa4e20f367cd011a6fa4f92f19c87.png";